var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class PromisesQueue {
  constructor(options = {}) {
    __publicField(this, "queue", []);
    __publicField(this, "pendingPromises", []);
    __publicField(this, "workingOnPromise", false);
    __publicField(this, "executeAllImmediately", false);
    // don't queue, run all promises immediately
    __publicField(this, "options");
    this.options = options;
  }
  enqueue(promise) {
    return new Promise((resolve, reject) => {
      this.queue.push({
        promise,
        resolve,
        reject
      });
      this.dequeue();
    });
  }
  // performs next step - take next promise in queue
  dequeue() {
    if (this.workingOnPromise && !this.executeAllImmediately) {
      return false;
    }
    const item = this.queue.shift();
    if (!item) {
      return false;
    } else {
      this.workingOnPromise = true;
      if (this.executeAllImmediately) {
        this.dequeue();
      }
      const currentPromise = item.promise();
      this.pendingPromises.push(
        currentPromise.then((value) => {
          item.resolve(value);
        }).catch((err) => {
          item.reject(err);
        }).finally(() => {
          var _a, _b;
          this.workingOnPromise = false;
          this.pendingPromises.splice(
            this.pendingPromises.indexOf(currentPromise),
            1
          );
          if (!this.pendingPromises.length && !this.queue.length) {
            (_b = (_a = this.options).onComplete) == null ? void 0 : _b.call(_a);
          }
          this.dequeue();
        })
      );
      return true;
    }
  }
}
export {
  PromisesQueue
};
//# sourceMappingURL=index.es.js.map
